module.exports = __webpack_public_path__ + "img/member_lip4.fd8098d3.png";